module.exports = __webpack_public_path__ + "files/9fec531ac949de0d62ec3c43d117bfa5.png";